import { useEvents } from "../../hooks";
import EventRow from "../../components/EventRow";

// Re-exported from the shared formatter so existing imports (EventDetail) keep
// working while time/date formatting lives in one civilian (12-hour) place
// (SPR-009 P2-2).
export { formatEventDate, formatTimeRange } from "../../utils/eventFormat";

/**
 * Events — Public upcoming-event feed (F-013, T-002).
 *
 * Lists future events from GET /api/events (sorted ascending by the backend),
 * styled to match the live site's "On the Road" schedule. Each card links to
 * the event detail page.
 */
export default function Events() {
  const { events, isLoading, error } = useEvents();

  return (
    <main data-testid="events-page" className="min-h-screen bg-cream text-ink font-body">
      <section className="max-w-3xl mx-auto px-4 py-16">
        <p className="font-heading tracking-[0.3em] text-teal-deep text-sm">ON THE ROAD</p>
        <h1 className="font-display text-5xl text-charcoal uppercase mb-2">Upcoming Events</h1>
        <p className="font-body text-ink/60 mb-8">
          Markets, festivals, and pop-ups around the Twin Cities. Chase the Silver Bullet.
        </p>

        {isLoading && (
          <p className="font-body text-ink/60 italic" data-testid="events-loading">
            Loading events…
          </p>
        )}
        {error && (
          <p className="font-body text-rust" data-testid="events-error">
            We couldn't load events right now. Try again soon.
          </p>
        )}
        {!isLoading && !error && events.length === 0 && (
          <p className="font-body text-ink/60 italic" data-testid="events-empty">
            No upcoming events scheduled yet — check back soon.
          </p>
        )}

        {!isLoading && !error && events.length > 0 && (
          <div className="grid gap-4">
            {events.map((e) => (
              <EventRow key={e.id} event={e} />
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
